// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".side-bar-delivery-free{display:grid;align-items:center;grid-template-columns:32px 1fr;grid-gap:12px;border-radius:8px;position:relative}.side-bar-delivery-free._free{padding:12px 16px;background-color:#ebfee8}.side-bar-delivery-free._add{padding:12px;background-color:#f0f2f7}.side-bar-delivery-free__icon{fill:#6ebc63}.side-bar-delivery-free__text{font-size:14px;line-height:24px;margin:0}.side-bar-delivery-free__text._bold{font-weight:700}", ""]);
// Exports
module.exports = exports;
